export const GOOGLE_OPTIMIZE_INTRO_STEP_DESC_TEST_ID = 'vFdzouQPQlC9Nnb5VLnfTA';
export const GOOGLE_OPTIMIZE_REQUEST_FORM_BLOCKING_API_CALL_TEST_ID = 'Pgl-JGWVTY6a8DX2SfPjAg';
export const GOOGLE_OPTIMIZE_HERO_IMAGE_Q_TEST_ID = 'gIjE5zNqRV-lMjlx7UXIfQ';
export const GOOGLE_OPTIMIZE_CTA_BUTTON_TEST_ID = 'e7hdhOuQQiO9J6A4NbAbVA';

/**
 * If you are doing AB testing, put the ExperimentID in this array.
 */
export const OPTIMIZE_TEST_ID_LIST: Array<string> = [
  GOOGLE_OPTIMIZE_INTRO_STEP_DESC_TEST_ID,
  GOOGLE_OPTIMIZE_REQUEST_FORM_BLOCKING_API_CALL_TEST_ID,
  GOOGLE_OPTIMIZE_HERO_IMAGE_Q_TEST_ID,
  GOOGLE_OPTIMIZE_CTA_BUTTON_TEST_ID,
];
